<template>
  <section>
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-lg-12" v-scroll-reveal.reset="{ delay: 0 }">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h3>List semua produk PO</h3>
            <a href>
              <router-link to="/listproduk" class="primary" tag="h4">Lihat Semua</router-link>
            </a>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 mb-3 mb-lg-5" v-for="listProducts in products" v-bind:key="listProducts.id" v-scroll-reveal.reset="{ delay: 300 }">
          <div class="card hover-box-shadow">
            <a href="#" class="d-block bg-gradient rounded-top">
              <img
                class="card-img-top hover-fade-out"
                v-bind:src="listProducts.productimage"
                alt="blog.5.image"
              />
            </a>
            <div class="card-body">
              <h5> {{ listProducts.produtname }} </h5>
              <p class="description-products">
                {{ listProducts.poname }}
              </p>
              <p class="primary lead">
                <strong> {{ listProducts.price }} </strong>
              </p>
              <p style="font-size: 12px;"></p>
              <div class="d-flex justify-content-between align-items-center">
                <a href="#" class="badge badge-pill badge-info">Pre-Order</a>
                <div class="text-small text-muted"> {{ listProducts.date }} </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ProductSection",
  data: function() {
    return {
      products: [
        {
          id: 1,
          seller: 'Pipit Agustin',
          location: 'Surabaya',
          produtname: 'Soto Ayam Lamongan Cak Kan',
          poname: 'Open P.O oleh-oleh express khas Bali',
          price: 'Rp 15,000',
          date: '30 Hari Lagi',
          productimage: 'assets/img/products/product-01.png'
        },
                {
          id: 1,
          seller: 'Pipit Agustin',
          location: 'Surabaya',
          produtname: 'Sate Ayam & Kambing Cak Hari - Kebon Sirih',
          poname: 'Open P.O oleh-oleh express khas Bali',
          price: 'Rp 15,000',
          date: '30 Hari Lagi',
          productimage: 'assets/img/products/product-02.png'
        }
      ]
    };
  }
};
</script>

<style>

.description-products {
  font-size: 13px; 
  color: #88919D;
}

</style>